// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/assessment/mondoo_assessment.actions.go

export const GET_ASSESSMENTS = "mondoo.assessment.Assessments.GetAssessments";
